module.exports = __webpack_public_path__ + "static/img/jinian@2x.e53a4670.png";